// See DirectUploadController from Rails Active Storage source
// 5.2: https://github.com/rails/rails/blob/5-2-stable/activestorage/app/frontend/activestorage/direct_upload_controller.js
// 6.0: https://github.com/rails/rails/blob/6-0-stable/activestorage/app/frontend/activestorage/direct_upload_controller.js

import { DirectUpload }  from '@rails/activestorage'
import { dispatchEvent } from '@rails/activestorage/src/helpers'

export class HfDirectUpload {

  constructor(input, file) {
    this.input = input
    this.file  = file

    this.directUpload = new DirectUpload(this.file, this.url, this)
    this.dispatch('initialize')
  }

  start() {
    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = this.input.name
    this.input.insertAdjacentElement('beforebegin', hiddenInput)

    this.dispatch('start')

    this.directUpload.create((error, attributes) => {
      if (error) {
        hiddenInput.parentNode.removeChild(hiddenInput)
        this.dispatchError(error)
      } else {
        hiddenInput.value = attributes.signed_id
      }

      this.dispatch('end')
      hiddenInput.remove()
    })
  }

  uploadRequestDidProgress(event) {
    const progress = (event.loaded / event.total) * 100

    if (progress) {
      this.dispatch('progress', { progress })
    }
  }

  get url() {
    return this.input.dataset.directUploadUrl
  }

  dispatch(name, detail = {}) {
    detail.file = this.file
    detail.id   = this.directUpload.id
    return dispatchEvent(this.input, `direct-upload:${name}`, { detail })
  }

  dispatchError(error) {
    const event = this.dispatch('error', { error })
    if (!event.defaultPrevented) {
      HF.consoleLog(error, {
        display: 'error',
        level:   'error'
      })
    }
  }

  // DirectUpload delegate

  // directUploadWillCreateBlobWithXHR(xhr) {
  //   this.dispatch('before-blob-request', { xhr })
  // }

  directUploadWillStoreFileWithXHR(xhr) {
    this.dispatch('before-storage-request', { xhr })
    xhr.upload.addEventListener('progress', (event) => this.uploadRequestDidProgress(event))
  }

}

export default HfDirectUpload
